import { GetServerSidePropsContext } from 'next'

import DecksTable from '@/components/DecksTable/DecksTable'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import MidBanner from '@/components/MidBanner/MidBanner'
import Panels from '@/components/Panels/Panels'
import { DecksTablePageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const DecksPage = ({ data }: DecksTablePageProps) => (
  <Main artCrop={data.container.json_dict.card.image_uris[0].art_crop}>
    <DefaultHead data={data} />
    <Panels data={data} />
    <MidBanner />
    <DecksTable rows={data.table} />
  </Main>
)

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  let url = context.query.commander as string

  if (context.query.f && context.params?.commander) {
    // Deck filters
    const params = {
      cmdr: context.params.commander as string,
      dir: 'decks',
      f: context.query.f as string,
    }
    const queryString = new URLSearchParams(params).toString()
    url = `${process.env.NEXT_PUBLIC_EDHREC_API_URL}/filters/?${queryString}`
  } else {
    if (context.query.tag) url = `${url}/${context.query.tag}`
    if (context.query.budget) url = `${url}/${context.query.budget}`
    url = `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/decks/${url}.json`
  }

  return serverSidePropsFor(url)
}

export default DecksPage
